import { render, staticRenderFns } from "./template_sidebar.vue?vue&type=template&id=3a533c28&scoped=true&"
import script from "./template_sidebar.vue?vue&type=script&lang=js&"
export * from "./template_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./template_sidebar.vue?vue&type=style&index=0&id=3a533c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a533c28",
  null
  
)

export default component.exports